module.exports = __webpack_public_path__ + "img/satellite.f3e0e4d2.gif";